import { render, staticRenderFns } from "./match_mini.vue?vue&type=template&id=256e8fa2&scoped=true&"
import script from "./match_mini.vue?vue&type=script&lang=js&"
export * from "./match_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e8fa2",
  null
  
)

export default component.exports